import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import getColumns from '../../../constants/tableColumnConstants';
import {goodsBalanceGet} from '../../../utils/apiRequest';
import {
  makeStyles,
} from '@material-ui/core';

const columns = [
  { id: 'name', label: 'Name', minWidth: 170, backgroundColor:"red" },
  { id: 'code', label: 'ISO\u00a0Code', minWidth: 100, backgroundColor:"red"  },
  {
    id: 'population',
    label: 'Population',
    minWidth: 170,
    align: 'right',
     backgroundColor:"red",
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'size',
    label: 'Size\u00a0(km\u00b2)',
    minWidth: 170,
    backgroundColor:"red",
    align: 'right',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'density',
    label: 'Density',
    minWidth: 170,
    align: 'right',
    format: (value) => value.toFixed(2),
    backgroundColor:"red",
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}
const useStyles = makeStyles((theme) => ({
  imageBox: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor:'red',
      alignItems: 'center',
  },}))

export default function StickyHeadTable() {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
    // const [formOpen, setFormOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [pagesToFetch, setPagesToFetch] = useState([]);
  const [waiting, setWaiting] = useState(false);
  const { t } = useTranslation();
  const columns = getColumns('balance_of_goods', t);
  
  
    useEffect(() => {
        setWaiting(true);

        const prms = [];
        for (let i of pagesToFetch) prms.push(goodsBalanceGet(i));

        Promise.all(prms)
            .then((res) => {
                const obj = [];
                res.forEach((el) => {
                    obj.push(...el.data.results);
                });
                setData([ ...data,...obj]);
                setCount(res[0].data.count);
            })
            .catch((err) => {
                setData([]);
            })
            .finally(() => setWaiting(false));
    }, [pagesToFetch]);

    useEffect(() => {
        setData([]);
        setPagesToFetch([1]);
    }, [refresh]);
    console.log(data, "data")

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell 
                  key={column.id}
                  align={column.align}
                  // className={classes.imageBox}  
                  style={{ minWidth: column.minWidth, backgroundColor:column.backgroundColor, color:column.color}}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={data.length} 
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
